export default "__VITE_ASSET__CbWtmRlj__"